module.exports = __webpack_public_path__ + "img/add-student-icon.7ac0bd3f.svg";